import { Typography } from 'antd';
import { BaseLayout } from 'features/navigation/components';
import React from 'react';
import { CreateMerchantForm } from '../components';

const CreateMerchantPage: React.FC = () => {
  return (
    <BaseLayout>
      <Typography.Title>Create Merchant</Typography.Title>
      <CreateMerchantForm />
    </BaseLayout>
  );
};

export { CreateMerchantPage };
